import { Stack } from "@mui/material";
import Toggle from './index'
export const LabeledToggle = ({ label, initialValue, onChange, disable = false, initalTrigger = true }) => (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
        <h3>{label}</h3>
        <Toggle initialValue={initialValue} onChange={onChange} disabled={disable} initalTrigger={initalTrigger} />
    </Stack>
);